"use client";
import dynamic from "next/dynamic";
import { useLazyLoad, LAZY_LOAD_CONFIGS } from "@hooks/useLazyLoad";

const ColorsSection = dynamic(() => import("./index"), {
  ssr: false,
  loading: () => <div className="colors-skeleton">Loading Colors...</div>,
});

export default function ColorsSectionClient(props: any) {
  const shouldLoad = useLazyLoad(LAZY_LOAD_CONFIGS.COLORS_SECTION);

  if (!shouldLoad) {
    return;
  }

  return <ColorsSection {...props} />;
}
